<template>
  <header :class="['topbar', 'd-flex', 'justify-content-between', 'align-items-center', 'px-3', 'py-2', 'shadow-sm', themeClass]">
    <div class="topbar-left d-flex align-items-center">
      <h4 class="m-0 page-title">{{ pageTitle }}</h4>
    </div>

    <div class="topbar-right d-flex align-items-center gap-3">
      <!-- Theme Toggle Button -->
      <button 
        @click="toggleTheme" 
        class="btn btn-outline-secondary theme-toggle-btn"
        :title="isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
      >
        <i :class="isDarkMode ? 'bi bi-sun-fill' : 'bi bi-moon-fill'"></i>
      </button>
      
      <div class="dropdown">
        <button
          class="btn btn-outline-secondary dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          @click="toggleDropdown"
          :aria-expanded="dropdownOpen"
        >
          <i class="bi bi-person-circle me-1"></i> {{ usuarioNombre }}
        </button>
        <ul class="dropdown-menu dropdown-menu-end" :class="{ show: dropdownOpen }" aria-labelledby="dropdownMenuButton">
          <li><router-link class="dropdown-item" to="/usuarios" @click="closeDropdown">Perfil</router-link></li>
          <li><router-link class="dropdown-item" to="/usuarios" @click="closeDropdown">Cambiar contraseña</router-link></li>
          <li><hr class="dropdown-divider"></li>
          <li><a class="dropdown-item text-danger" @click.prevent="cerrarSesion">Cerrar sesión</a></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import themeManager from '@/store/theme'
import { mapGetters } from 'vuex'
import auth from '@/services/servicioAutenticacion'

export default {
  name: 'AdminTopbar',
  data() {
    return {
      empresaNombre: '',
      dropdownOpen: false
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  computed: {
    ...mapGetters(['currentUser']),
    themeClass() {
      return themeManager.themeClass
    },
    isDarkMode() {
      return themeManager.isDarkMode
    },
    usuarioNombre() {
      return this.currentUser?.name || this.currentUser?.email || 'Admin'
    },
    pageTitle() {
      const routeName = this.$route.name;
      
      // Mapeo de rutas a títulos
      const titleMap = {
        'AdminDashboard': 'Dashboard Principal',
        'AdminEmpresas': 'Gestión de Empresas',
        'AdminEmpresaNueva': 'Nueva Empresa',
        'AdminEmpresaSubdominios': 'Subdominios',
        'AdminModulos': 'Módulos Disponibles',
        'AdminModulosPermisos': 'Permisos de Módulos',
        'AdminModulosActivacion': 'Activación de Módulos',
        'AdminFacturacionSuscripciones': 'Suscripciones',
        'AdminFacturacionPagos': 'Pagos',
        'AdminFacturacionPlanes': 'Planes de Suscripción',
        'AdminReportesEmpresas': 'Estadísticas de Empresas',
        'AdminReportesIngresos': 'Reportes de Ingresos',
        'AdminReportesUso': 'Reportes de Uso',
        'AdminConfiguracionUsuarios': 'Gestión de Usuarios',
  'AdminConfiguracionParametros': 'Parámetros del Sistema'
      };
      
      return titleMap[routeName] || 'SICECOM Admin';
    }
  },
  methods: {
    toggleTheme() {
      themeManager.toggleTheme()
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    closeDropdown() {
      this.dropdownOpen = false
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.dropdown')
      if (this.dropdownOpen && dropdown && !dropdown.contains(event.target)) {
        this.dropdownOpen = false
      }
    },
    cerrarSesion() {
      this.$store.commit('clearAuth');
      auth.cerrarSesion()
      this.$router.push('/iniciar-sesion');
    }
  }
};
</script>

<style>
.topbar {
  background-color: var(--header-bg);
  border-bottom: 1px solid var(--header-border);
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 1030;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.theme-toggle-btn {
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  background: transparent;
  padding: 0.375rem 0.5rem;
  transition: all 0.3s ease;
}

.theme-toggle-btn:hover {
  background-color: var(--bg-tertiary);
  border-color: var(--border-color);
  color: var(--text-primary);
  transform: scale(1.05);
}

.theme-toggle-btn:focus {
  box-shadow: 0 0 0 0.25rem rgba(17, 115, 212, 0.25);
}

.dropdown-menu {
  background-color: var(--modal-bg);
  border-color: var(--border-color);
  box-shadow: var(--card-shadow);
}

.dropdown-item {
  color: var(--text-primary);
  transition: background-color 0.3s ease;
}

.dropdown-item:hover {
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
}

.dropdown-divider {
  border-top-color: var(--border-color);
}

.page-title {
  color: var(--text-primary);
  font-weight: 600;
  transition: color 0.3s ease;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .topbar {
    padding: 0.5rem 1rem;
  }
  
  .theme-toggle-btn {
    padding: 0.25rem 0.4rem;
  }
  
  .page-title {
    font-size: 1.1rem;
  }
}



</style>

